import NotifyBindAccount from './notify-bind-account.vue';

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.notifyBindAccount = function () {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(NotifyBindAccount);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })

        return vueInstance.toBindAccount(...arguments)
    }
}


export default Plugin;
